import React, { useState } from "react";
import {
    Stepper,
    Step,
    useTheme,
    StepLabel,
    Typography,
    Button,
    Box,
    Grid,
    Stack,
    Link
} from "@mui/material";
import StepContent from "@mui/material/StepContent";
import { tokens } from "../../../assets/theme";

import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import ActivityHeader from "./ActivityHeader";
import AxionControls from "../../../components/controls/AxionControls";
import moment from "moment";
import messages from "./messages";
import { FormattedMessage, useIntl } from "react-intl";

const ActivityViewer = (props) => {
    console.log(moment.tz(moment(), "Europe/Stockholm"));
    const { activity, setShowBackdrop, setOpenPopup } = props;
    const [activeStep, setActiveStep] = useState(0);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [alarm, setAlarm] = useState(props.activity.type === 2);
    const { formatMessage } = useIntl();
    const [closers, setClosers] = useState([]);

    React.useEffect(() => {
        setClosers([{ id: props.loggedInUser, title: `Inloggad användare (${props.loggedInUser})` }, ...props.users.map((user) => ({ id: user.username, title: `${user.name} (${user.username})` }))]);
    }, [props.users]);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    console.log("activity", props.activity)

    return (
        <div>
            <ActivityHeader
                setOpenPopup={props.setOpenPopup}
                setShowBackdrop={props.setShowBackdrop}
                activity={props.activity}
                activityResult={props.activityResult}
                activityReadOnly={props.activityReadOnly}
            />
            <Box
                m="20px"
                x={{ maxWidht: 400, backgroundColor: colors.primary[700] }}
                sx={{

                    "& .Mui-completed": {
                        color: "#1b8b1e !important",
                    },
                    "& .Mui-active": {
                        color: `${colors.yellow[600]} !important`,
                    },
                }}
            >
                <Stepper m="10px" activeStep={activeStep} orientation="vertical">
                    {props.activity.activitySteps.map((step, index) => (
                        <Step m="10px" key={index} sx={{ backgroundColor: colors.primary[500] }}>
                            <StepLabel
                                sx={{ m: 2 }}
                                optional={
                                    index === 2 ? (
                                        <Typography variant="caption"><FormattedMessage {...messages.lastStep} /> </Typography>
                                    ) : null
                                }
                            >
                                <Typography variant="h6"><FormattedMessage {...messages.step} /> {index + 1}</Typography>
                            </StepLabel>
                            <StepContent>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Grid container spacing={2}>

                                        <Grid item xs={4}>
                                            <Box><FormattedMessage {...messages.picture} /></Box>
                                            <Box justifyContent="center" display="flex">
                                                {step.activityMediaFiles.map((mediaFile, fileIndex) => (
                                                    <a href={"/api/job/activities/image?imageurl=" + encodeURIComponent(mediaFile.fileName) + "&type=" + mediaFile.fileType} target="_blank" rel="noopener noreferrer">
                                                        <img
                                                            style={{
                                                                maxWidth: "100%",
                                                                maxHeight: "100%",
                                                                // height: "auto",
                                                                padding: "0",
                                                                margin: "0",
                                                                marginTop: 11,
                                                                borderRadius: 4,
                                                            }}
                                                            src={mediaFile.fileName}
                                                            alt="no pic"
                                                        />
                                                    </a>
                                                ))}
                                            </Box>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <FormattedMessage {...messages.instructionText} />
                                            <AxionControls.AxionMultiLineText
                                                disabled={true}
                                                defaultValue={step.text} rows={15} />

                                        </Grid>
                                    </Grid>
                                </Box>

                                <Box sx={{ mb: 2, mt: 2 }} display="flex" justifyContent="space-between" alignItems="center">
                                    <Box display="flex" gap={1}>
                                        <Button
                                            variant="contained"
                                            onClick={handleNext}
                                            sx={{
                                                mt: 1,
                                                mr: 1,
                                                boxShadow: "none",
                                                backgroundColor: "#799c4a",
                                                "&:hover": {
                                                    backgroundColor: "#5e7939",
                                                    borderColor: "#5e7939",
                                                    boxShadow: "none",
                                                },
                                            }}
                                        >
                                            {index === props.activity.activitySteps.length - 1 && !props.activityReadOnly
                                                ? (alarm ? <FormattedMessage {...messages.alarmBtnFinish} /> : <FormattedMessage {...messages.btnFinish} />)
                                                : <FormattedMessage {...messages.btnContinue} />}
                                        </Button>
                                        <Button
                                            disabled={index === 0}
                                            onClick={handleBack}
                                            sx={{
                                                mt: 1,
                                                mr: 1,
                                                backgroundColor: colors.redAccent[500],
                                                color: "white",
                                                "&:hover": {
                                                    backgroundColor: colors.redAccent[700],
                                                    borderColor: "#0062cc",
                                                    boxShadow: "none",
                                                },
                                            }}
                                        >

                                            <FormattedMessage {...messages.btnBack} />
                                        </Button>
                                    </Box>
                                    <Box display="flex" gap={1}>
                                        {alarm && !props.activityReadOnly && (
                                            <>
                                                <AxionControls.AxionSelect
                                                    sx={{ width: 150, paddingRight: '6px' }}
                                                    options={[
                                                        { id: 0, title: '-' },
                                                        { id: 10, title: '10 min' },
                                                        { id: 30, title: '30 min' },
                                                        { id: 60, title: '1 h' },
                                                        { id: 120, title: '2 h' },
                                                        { id: 300, title: '5 h' },
                                                        { id: 480, title: '8 h' },
                                                        { id: 720, title: '12 h' },
                                                        { id: 1440, title: '24 h' },
                                                    ]
                                                    }
                                                    showNoneOption={false}
                                                    name="autocodeLength"
                                                    label={<FormattedMessage {...messages.pauseTime} />}
                                                    value={props.activityPause.pauseTime}
                                                    onChange={props.handleChangePauseTime}
                                                />
                                                <Button
                                                    variant="contained"
                                                    onClick={props.handlePauseActivity}
                                                    disabled={props.activityPause.pauseTime === undefined || props.activityPause.pauseTime !== null ? false : true}
                                                    sx={{
                                                        mt: 1,
                                                        mr: 1,
                                                        boxShadow: "none",
                                                        backgroundColor: colors.blueAccent[600],
                                                        "&:hover": {
                                                            backgroundColor: colors.blueAccent[700],
                                                            borderColor: "#5e7939",
                                                            boxShadow: "none",
                                                        },
                                                    }}
                                                >
                                                    <FormattedMessage {...messages.alarmBtnPause} />
                                                </Button>
                                            </>
                                        )}
                                    </Box>
                                </Box>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
                {activeStep === props.activity.activitySteps.length && (
                    <Box
                        sx={{
                            p: 2,
                            backgroundColor: colors.primary[600],
                            color: "#799c4a",
                        }}
                    >
                        {!props.activityReadOnly && (
                            <>
                                <Box sx={{ mb: 2 }}>
                                    <Box><FormattedMessage {...messages.closeComment} /></Box>
                                    <AxionControls.AxionMultiLineText
                                        defaultValue={props.activity.closeComment ?? ""}
                                        onChange={props.handleChangeCloseComment}
                                        rows={3}
                                    />
                                </Box>
                                <Stack
                                    direction="row"
                                    height={45}
                                    width="80%"
                                    marginLeft={2}
                                    spacing={2}
                                >

                                    <Button
                                        onClick={props.handleCloseActivity}
                                        size="small"
                                        sx={{
                                            backgroundColor: colors.dashbordGreen[700],
                                            color: "white",
                                            "&:hover": {
                                                backgroundColor: colors.dashbordGreen[800],
                                                borderColor: "#0062cc",
                                                boxShadow: "none",
                                            },
                                        }}
                                    >
                                        <CheckIcon fontSize="inherit" sx={{ color: "white" }} />
                                    </Button>
                                    <Button
                                        onClick={handleReset}
                                        size="small"
                                        sx={{
                                            backgroundColor: colors.yellow[600],
                                            color: "white",
                                            "&:hover": {
                                                backgroundColor: colors.yellow[700],
                                                borderColor: "#0062cc",
                                                boxShadow: "none",
                                            },
                                        }}
                                    >
                                        Reset
                                    </Button>
                                    <Box>
                                        <AxionControls.AxionSelect
                                            label="Signera som"
                                            sx={{ width: 500, paddingRight: '6px' }}
                                            options={closers}
                                            showNoneOption={false}
                                            name="activityCloser"
                                            value={props.activity.activityCloser}
                                            onChange={props.handleActivityCloser}
                                        />
                                    </Box>
                                </Stack>
                            </>
                        )}
                        {props.activityReadOnly && (
                            <>
                                <Box sx={{ mb: 2 }}>
                                    <Box><FormattedMessage {...messages.closeComment} /></Box>
                                    <AxionControls.AxionTextBoxReadOnly
                                        value={props.activity.closeComment ?? ""}
                                        rows={3}
                                    />
                                </Box>
                            </>
                        )}
                    </Box>

                )}
            </Box>
        </div>
    );
};

export default ActivityViewer;
